import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddDocument from './adddocument/index'
import DocumentList from './documentlist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddDocumentProtected_ma = userIsCommitteeAdminRedir(AddDocument)
const DocumentListProtected_ma = userIsCommitteeAdminRedir(DocumentList)

const DocumentDetails = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* Document Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/document-list`} />
            <Route path={`${match.url}/add-document/:id?`} component={AddDocumentProtected_ma} />
            <Route path={`${match.url}/document-list/:id?`} component={DocumentListProtected_ma} />
        </Switch>
    </div>
);

export default DocumentDetails;



// WEBPACK FOOTER //
// ./app/documentdetails/index.js